// Partners on sites and communities see "Community" where labels say "Property".
export const resolveColumnLabel = (label: string, Property: string): string =>
  label.includes("Property") ? Property + label.split("Property")[1] : label;
